<script setup lang="ts">
import { RouterView } from 'vue-router'
import AuthOverlayGate from '@/components/layout/AuthOverlayGate.vue'
</script>

<template>
  <div class="relative h-full w-full">
    <RouterView />
    <AuthOverlayGate />
  </div>
</template>
